import { Common_parseOptions, Common_GenericOptions_Parse_9AE2F7C, Common_GenericOptions__ToReactElement_Z6D3CD4B7 } from "../Common.fs.js";
import * as react from "react";
import { keyValueList } from "../../fable-library.3.1.5/MapUtil.js";

export function footer(options, children) {
    return Common_GenericOptions__ToReactElement_Z6D3CD4B7(Common_GenericOptions_Parse_9AE2F7C(options, (result, option) => Common_parseOptions(result, option), "footer"), (props, children_1) => react.createElement("footer", keyValueList(props, 1), ...children_1), children);
}

